

<button *ngIf= '!showUnselect' type = "button" (click) = 'store()'>select</button>

<button *ngIf= 'showUnselect' type = "button" (click) = 'remove()'>unselect</button>

